import React from 'react';
import { Card, CardContent, Typography, CardMedia, Grid, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  // const randomId = Math.floor(Math.random() * 10000); // Generate a random ID

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Link to={`/product/product-details/${product.id}`} style={{ textDecoration: 'none' }}>
        <Card 
          sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            height: '100%',
            borderRadius: 2, 
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            '&:hover': { transform: 'scale(1.05)' },
            transition: 'transform 0.3s ease-in-out',
          }}
        >
          <Box sx={{ position: 'relative', overflow: 'hidden', borderRadius: '4px 4px 0 0' }}>
            <CardMedia
              component="img"
              height="200"
              image={product.image}
              alt={product.name}
              sx={{ 
                transition: 'transform 0.5s ease',
                '&:hover': { transform: 'scale(1.1)' } 
              }}
            />
          </Box>
          <CardContent 
            sx={{ 
              flexGrow: 1, 
              backgroundColor: '#005044', 
              color: '#fff',
              display: 'flex', 
              flexDirection: 'column',
              justifyContent: 'space-between',
              padding: 3 
            }}
          >
            <Typography 
              variant="h6" 
              component="div" 
              sx={{ 
                fontWeight: 'bold', 
                fontSize: '1.2rem', 
                marginBottom: 2
              }}
            >
              {product.name}
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                marginBottom: 2, 
                fontSize: '0.9rem' 
              }}
            >
              {product.details}
            </Typography>
            <Button 
              variant="contained" 
              color="primary"
              sx={{
                alignSelf: 'center',
                textTransform: 'uppercase',
                fontSize: '0.9rem',
                backgroundColor: '#FFCC00',
                color: '#333',
                '&:hover': {
                  backgroundColor: '#FFB700',
                }
              }}
            >
              View More
            </Button>
          </CardContent>
        </Card>
      </Link>
    </Grid>
  );
};

export default ProductCard;
